<template>
  <div class="start_voting_button_container">
    <button class="btn btn-primary" type="button"
    v-touch:tap="announce_button_clicked"
    :class="width"
    >
      <span class="btn_icon"><font-awesome-icon :icon="icon"></font-awesome-icon></span>{{button_text}}
    </button>
  </div>
</template>

<script>
import router from '@/router';
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faCheckDouble,
  faClipboardCheck
} from '@fortawesome/free-solid-svg-icons';
library.add(
  faCheckDouble,
  faClipboardCheck
);

export default {
  name: 'large_centered_button',
  props: [
    'button_text',
    'icon',
    'width'
  ],
  data () {
    return {
      
    }
  },
  methods: {
    announce_button_clicked: function() {
      this.$emit('button_clicked', '');
    }
  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

.start_voting_button_container {

  text-align: center;
  margin: 1em 0;

  .btn_icon {
    margin-right: 0.5em;
  }

  .btn-primary {
    background: $dcom-purple;
    border-color: $dcom-purple;
    text-transform: uppercase;
    font-size: 1.8em;
    padding: 0.25em;
  }

  .full {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/buttons/large_centered_button.vue